import Image from "next/legacy/image";
import { CheckCircle } from "@phosphor-icons/react";

function UserPreferenceTopicRegister({
  selected,
  topic,
  thumbnail,
  onChange,
  uuid,
  size = "large",
}) {
  const elementId = `preference-${topic.toLowerCase()}`;
  return (
    <div
      className={`cursor-pointer overflow-hidden rounded-md group ring-2 ring-offset-4 ${
        selected
          ? "ring-orange-1 ring-offset-background"
          : "ring-transparent ring-offset-transparent"
      }`}
    >
      <input
        type='checkbox'
        id={elementId}
        checked={selected || false}
        onChange={onChange}
        value={uuid}
        className='hidden'
      />
      <label className='relative block cursor-pointer' htmlFor={elementId}>
        <div className={`relative aspect-[4/3] ${!selected && "grayscale"}`}>
          <Image
            src={thumbnail || ""}
            alt={topic}
            layout={"fill"}
            objectFit={"cover"}
          />
        </div>
        {selected && (
          <div className='absolute border-2 border-white rounded-full top-1 left-1'>
            <CheckCircle weight='fill' className='text-2xl text-white' />
          </div>
        )}
        {selected ? (
          <span className='absolute inset-0 w-full h-full bg-gradient-to-b from-transparent to-red-1/40'></span>
        ) : (
          <span className='absolute inset-0 w-full h-full bg-gradient-to-b from-transparent to-background'></span>
        )}

        <p className='absolute text-xs font-bold text-left text-white bottom-2 left-2 lg:text-xl lg:leading-tight'>
          {topic}
        </p>
      </label>
    </div>
  );
}

export default UserPreferenceTopicRegister;
